export default __webpack_public_path__ + "static/media/msg.384229d8.svg";